module.exports = __webpack_public_path__ + "static/programs-d1c5d63fe2334ced8cb690f1921557c8.png";